/* agent-pet — animations and structural styles
 * Ported from nexu-io/open-design (Apache-2.0)
 * https://github.com/nexu-io/open-design
 */

@keyframes ap-spin {
  to { transform: rotate(360deg); }
}

@keyframes ap-float {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-8px); }
}

@keyframes ap-bounce {
  0%, 100% { transform: translateY(0) scaleY(1); }
  40%       { transform: translateY(-12px) scaleY(1.05); }
  60%       { transform: translateY(-10px) scaleY(1); }
}

@keyframes ap-sway {
  0%, 100% { transform: rotate(-4deg); }
  50%       { transform: rotate(4deg); }
}

@keyframes ap-wiggle {
  0%, 100% { transform: rotate(-6deg) scale(1); }
  25%       { transform: rotate(6deg) scale(1.05); }
  75%       { transform: rotate(-3deg) scale(0.97); }
}

@keyframes ap-frames {
  from { background-position-x: 0%; }
  to   { background-position-x: 100%; }
}

/* Manifest action jump arc — translateY follows a parabola peaking at
 * --ap-jump-peak (a negative px value). Used by ActionSpec.jumpHeight
 * so a SHORYUKEN actually leaves the ground. The keyframe samples the
 * arc at quarter intervals so the peak is held for ~25% of the duration
 * (roughly matches a real jump's hang time at apex). */
@keyframes ap-jump-arc {
  0%   { transform: translateY(0); }
  25%  { transform: translateY(calc(var(--ap-jump-peak, -64px) * 0.75)); }
  50%  { transform: translateY(var(--ap-jump-peak, -64px)); }
  75%  { transform: translateY(calc(var(--ap-jump-peak, -64px) * 0.75)); }
  100% { transform: translateY(0); }
}

/* Overlay anchor — fixed position set inline via React */
.ap-overlay {
  pointer-events: none;
}

.ap-overlay > * {
  pointer-events: all;
}

/* Sprite cursor */
.ap-sprite {
  cursor: grab;
}
.ap-sprite:active {
  cursor: grabbing;
}

/* Image rendering for pixel-art spritesheets */
.ap-image {
  image-rendering: pixelated;
  image-rendering: crisp-edges;
}

/* ── Speech bubble ────────────────────────────────────────────────────
 * Static structure here; only the side-flip (--left / --right) is toggled
 * at runtime. The accent-derived colours come from --pet-accent set on the
 * overlay root by overlay.ts:setConfig(). color-mix gives us the 20% shadow
 * alpha without hex-string concatenation. */
.ap-bubble {
  position: absolute;
  bottom: calc(100% + 8px);
  pointer-events: auto;
  background: var(--ap-bubble-bg, #1a1a1a);
  color: var(--ap-bubble-text, #e8e8e8);
  border: 1.5px solid var(--pet-accent, #7eb8da);
  border-radius: 10px;
  padding: 8px 10px;
  max-width: 240px;
  width: max-content;
  font-size: 12px;
  box-shadow: 0 2px 12px color-mix(in srgb, var(--pet-accent, #7eb8da) 20%, transparent);
}
.ap-bubble--left  { left: 0; right: auto; }
.ap-bubble--right { right: 0; left: auto; }
